import React from "react"
import { StudioManager } from "../../studio-manager";

const tags = [
  'SYNTH',
  'WAVE',
  'INDIE',
  'HIP HOP',
  'HOUSE',
  'WORLD',
  'AMBIENT',
  'EXPERIMENTAL',
  'DISCO',
  'BOOGIE',
  'BEATS',
  'ROCK',
  'ELECTRO',
  'ELECTRONICA',
  'DOWNTEMPO',
  'BREAKS',
  'FUNK',
  'SOUL',
  'JAZZ',
  'TECHNO',
  'TRANCE',
  'TRAP',
  'DUB',
  'STAFFPICK',
  'ALLSTARS'
].sort();

export class Search extends React.Component {
  constructor () {
    super();
    this.state = { tags: [] };
  }

  componentDidMount () {
    this.setState({ tags: StudioManager.instance.tags });
    StudioManager.instance.on('episodes-loaded', this.ready);
    StudioManager.instance.on('search-start', this.startSearch);
    StudioManager.instance.on('search-end', this.startSearch);
  }

  componentWillUnmount () {
    StudioManager.instance.off('episodes-loaded', this.ready);
  }

  startSearch = (event) => {
    window.scrollTo(0, 0);
    this.input.value = event.term;
  }
  
  ready = () => {
    this.setState({ tags: StudioManager.instance.tags });
  }

  update = () => {
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(this.submit, 800);
  }

  submit = (e) => {
    if (e) e.preventDefault();
    if (this.timeout) clearTimeout(this.timeout);
    StudioManager.instance.search(this.input.value);
  }

  close = () => {
    this.props.onClose();
  }

  render () {
    return (
      <div className="search">
        <div className="search__close" onClick={this.close}><img src="/images/cross.svg" /></div>
        <form onSubmit={this.submit}><input ref={_ => this.input =  _} className="search__input" placeholder="What are you looking for?" onChange={this.update} /></form>
        
        <div className="search__tags">
          { tags.map(tag => <span className="tag" onClick={() => StudioManager.instance.search('#' + tag, true) }>{ tag }</span>) }
        </div>
      </div>
    )
  }
}
